<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs :crm_id="this.$route.params.crmid"/>
        <div class="table-agile-info">
          <div class="common-new-title mode2">
            <span>支付列表</span>
          </div>
          <div class="searchList">
            <div class="box-content">
              <label class="form-tit">平台名称</label>
              <el-select
                class="jm-input280"
                v-model="searchData.project_id"
                clearable
                placeholder="请选择">
                <el-option
                  v-for="item in selectDict.projects"
                  :label="item.value"
                  :key="item.id"
                  :value="item.id"/>
              </el-select>
            </div>
            <div class="box-content">
              <label class="form-tit">付款时间</label>
              <el-date-picker
                class="jm-input280"
                v-model="searchData.paid_time"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </div>
            <div class="box-content">
              <label class="form-tit">缴费类型</label>
              <el-select
                class="jm-input280"
                v-model="searchData.trade_type"
                clearable
                placeholder="请选择">
                <el-option
                  v-for="item in selectDict.trade_type"
                  :label="item.value"
                  :key="item.id"
                  :value="item.id"/>
              </el-select>
            </div>
            <div class="box-content">
              <label class="form-tit">订单编号</label>
              <el-input
                v-model="searchData.big_order_no"
                class="jm-input280"/>
            </div>
            <div class="box-content">
              <label class="form-tit">拓中流水号</label>
              <el-input
                v-model="searchData.order_no"
                class="jm-input280"/>
            </div>
            <div class="box-content">
              <label class="form-tit">交易流水号</label>
              <el-input
                v-model="searchData.transaction_id"
                class="jm-input280"/>
            </div>

            <div class="box-content">
              <label class="form-tit">支付方式</label>
              <el-select
                class="jm-input280"
                v-model="searchData.payment_method"
                clearable
                placeholder="请选择">
                <el-option
                  v-for="item in selectDict.payment_method"
                  :label="item.value"
                  :key="item.id"
                  :value="item.id"/>
              </el-select>
            </div>
            <div class="box-content">
              <label class="form-tit">支付金额</label>
              <div style="display:inline-block;width:290px">
                <el-input
                  placeholder="起始金额"
                  class="jm-input135"
                  v-model="searchData.total_amount[0]">
                </el-input>
                <el-input
                  placeholder="结束金额"
                  class="jm-input135"
                  v-model="searchData.total_amount[1]">
                </el-input>
              </div>
              <!-- <div>
                    <el-input
                      placeholder="起始金额"
                      class="jm-input135"
                      v-model="searchData.total_amount[0]">
                    </el-input>
                    <el-input
                      placeholder="结束金额"
                      class="jm-input135"
                      v-model="searchData.total_amount[1]">
                    </el-input>
                  </div> -->
            </div>
            <div class="box-content">
              <label class="form-tit">缴费币种</label>
              <el-select
                class="jm-input280"
                v-model="searchData.currency_type"
                clearable
                placeholder="请选择">
                <el-option label="使用外币" :key="-1" value="foreign"/>
                <el-option
                  v-for="item in selectDict.currency_type"
                  :label="item.value"
                  :key="item.id"
                  :value="item.id"/>
              </el-select>
            </div>
            <!-- <div class="box-content">
                  <label class="form-tit">拓中流水号</label>
                  <el-input
                    v-model="searchData.order_no"
                    class="jm-input280"/>
                </div>
                <div class="box-content">
                  <label class="form-tit">交易流水号</label>
                  <el-input
                    v-model="searchData.transaction_id"
                    class="jm-input280"/>
                </div> -->
            <div class="box-content">
              <label class="form-tit">用户姓名</label>
              <el-input
                v-model="searchData.pub_account"
                class="jm-input280"/>
            </div>
            <div class="box-content">
              <label class="form-tit">用户ID</label>
              <el-input
                v-model="searchData.pub_userid"
                class="jm-input280"/>
            </div>
            <!-- <div class="box-content">
                  <label class="form-tit">缴费类型</label>
                  <el-select
                    class="jm-input280"
                    v-model="searchData.trade_type"
                    clearable
                    placeholder="请选择">
                    <el-option
                      v-for="item in selectDict.trade_type"
                      :label="item.value"
                      :key="item.id"
                      :value="item.id"/>
                  </el-select>
                </div> -->
            <div class="box-content">
              <label class="form-tit">审核状态</label>
              <el-select
                class="jm-input280"
                v-model="searchData.finance_status"
                clearable
                placeholder="请选择">
                <el-option
                  v-for="item in selectDict.finance_status"
                  :label="item.value"
                  :key="item.id"
                  :value="item.id"/>
              </el-select>
            </div>
            <div class="box-content">
              <label class="form-tit">财务备注</label>
              <el-input
                v-model="searchData.finance_message"
                class="jm-input280"/>
            </div>
            <div class="box-content">
              <label class="form-tit">到账日期</label>
              <el-date-picker
                class="jm-input280"
                v-model="searchData.confirm_time"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </div>
            <div class="box-content">
              <label class="form-tit">发起人</label>
              <el-input
                v-model="searchData.pub_teacher"
                class="jm-input280"/>
            </div>
            <div class="box-content box-content-double">
              <label class="form-tit">报账时间</label>
              <el-date-picker
                class="jm-input500"
                v-model="searchData.update_time"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间">
              </el-date-picker>
            </div>
          </div>
          <div class="searchBottom">
            <el-button
              class="jm-input-common3"
              type="primary"
              @click="() => this.$store.commit('updateRefresh', true)">搜索</el-button>
            <el-button
              class="jm-input-common3"
              type="default"
              @click="resetFields">重置</el-button>
            <el-button
              class="jm-input-common3"
              type="success"
              @click="exportDetails"
              :loading="btnLoading">导出明细</el-button>
            <el-button
              v-if="$hasPermission(171)"
              type="warning"
              @click="$router.push({ name: 'financePayConfirm' })">批量到账确认</el-button>
          </div>
          <!--列表部分 start -->
          <jm-tableList
            :url="getListurl"
            :search-data="searchData"
          >
            <div name="perfix" slot="perfix" slot-scope="perfix" class="money-end-wrap">
              <a href="javascript:void(0)" @click="currencyUnit = Number(!currencyUnit)">
                <b v-if="currencyUnit">总额：{{ formatCurrency(perfix.data.totalIncome) }}（{{ formatCurrency(perfix.data.totalIncomeConfirmed) }}）元</b>
                <b v-else>总额：{{ formatCurrency(perfix.data.totalIncome / 10000) }}（{{ formatCurrency(perfix.data.totalIncomeConfirmed / 10000) }}）万元</b>
                <el-popover
                  placement="bottom"
                  trigger="hover"
                  content="总额标识：当前查询条件的收入总额(已确认收入总额)">
                  <el-button slot="reference" type="primary" icon="el-icon-question" style="padding:0; font-size: 20px"></el-button>
                </el-popover>
              </a>
            </div>
            <el-table-column
              slot="order_no"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label">
              <template slot-scope="scope">
                <el-popover
                  placement="top"
                  width="200"
                  trigger="hover">
                  {{ scope.row.order_no }}
                  <span slot="reference" class="white-nowrap">{{ scope.row.order_no }}</span>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column
              slot="transaction_id"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label">
              <template slot-scope="scope">
                <el-popover
                  placement="top"
                  width="200"
                  trigger="hover">
                  {{ scope.row.transaction_id }}
                  <span slot="reference" class="white-nowrap">{{ scope.row.transaction_id }}</span>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column
              slot="title"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
            >
              <template slot-scope="scope">
                <el-popover
                  placement="top"
                  width="200"
                  trigger="hover">
                  {{ scope.row.title }}
                  <span slot="reference" class="white-nowrap">{{ scope.row.title }}</span>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column
              slot="memo"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
            >
              <template slot-scope="scope">
                <el-popover
                  placement="top"
                  width="200"
                  trigger="hover">
                  {{ scope.row.memo }}
                  <span slot="reference" class="white-nowrap">{{ scope.row.memo }}</span>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column
              slot="finance_status_str"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
            >
              <template slot-scope="props">
                <el-tag :type="tagColors[props.row.finance_status]">{{ props.row.finance_status_str }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column
              slot="total_amount"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
            >
              <template slot-scope="props">
                <p>
                  <span>{{ Number(props.row.total_amount) }}</span><br>
                  <span v-if="Number(props.row.real_amount)">({{ Number(props.row.real_amount) }}{{ props.row.currency_type_str }})</span>
                </p>
              </template>
            </el-table-column>
            <el-table-column slot="confirm_time" label="到账日期">
              <a v-if="$hasPermission(171)" slot-scope="scope" @click="editConfirmTime(scope.row)" href="javascript:void(0)">
                {{ scope.row.confirm_time }}
              </a>
              <template v-else>
                {{ scope.row.confirm_time }}
              </template>
            </el-table-column>
            <el-table-column
              slot="finance_message"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
            >
              <template slot-scope="props">
                <el-tooltip popper-class="table-tooltip-area" effect="dark" :content="props.row.finance_message" placement="left">
                  <span>{{ props.row.finance_message }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              slot="lastColumn"
              fixed="right"
              align="center"
              header-align="center"
              width="300"
              label="操作">
              <template slot-scope="scope">
                <router-link
                  v-show="scope.row.project_id === 10"
                  target="_blank"
                  :to="{ name: 'gkryOrderDetail', params: { id:scope.row.big_order_id }}">
                  <el-button
                    type="success"
                    size="small">查看详情</el-button>
                </router-link>
                <router-link
                  v-show="scope.row.project_id === 11"
                  target="_blank"
                  :to="{ name: 'trainingOrderDetail', params: { id:scope.row.big_order_id }}">
                  <el-button
                    type="primary"
                    size="small">查看详情</el-button>
                </router-link>
                <router-link
                  v-show="scope.row.project_id === 12"
                  target="_blank"
                  :to="{ name: 'jiemoOrderDetail', params: { id:scope.row.big_order_id }}">
                  <el-button
                    type="primary"
                    size="small">查看详情</el-button>
                </router-link>
                <router-link
                  v-show="scope.row.project_id === 13"
                  target="_blank"
                  :to="{ name: 'qcrbOrderDetail', params: { id:scope.row.big_order_id }}">
                  <el-button
                    type="primary"
                    size="small">查看详情</el-button>
                </router-link>
                <router-link
                  v-show="scope.row.project_id === 14"
                  target="_blank"
                  :to="{ name: 'nseriesOrderDetail', params: { id:scope.row.big_order_id }}">
                  <el-button
                    type="primary"
                    size="small">查看详情</el-button>
                </router-link>
                <el-button
                  type="primary"
                  :loading="btnLoading"
                  @click="openAccountDialog(scope.row)"
                  size="small">报账文本</el-button>
                <el-button
                  type="warning"
                  :disabled="!scope.row.pub_userid"
                  :style="!scope.row.pub_userid ? 'color:#ccc' : ''"
                  @click="searchHistory(scope.row)"
                  size="small">历史支付</el-button>
                <br />
                <el-button
                  v-if="$hasPermission(171)"
                  type="primary"
                  v-show="Number(scope.row.finance_status) === 0 || Number(scope.row.finance_status) === 1"
                  @click="confirmTrade(scope.row)"
                  size="small">到账确认</el-button>
                <el-button
                  v-if="$hasPermission(171)"
                  type="danger"
                  :loading="btnLoading"
                  v-show="Number(scope.row.finance_status) === 0 || Number(scope.row.finance_status) === 1"
                  @click="refuseTrade(scope.row)"
                  size="small">拒绝</el-button>
              </template>
            </el-table-column>
          </jm-tableList>
          <!--列表部分 end-->
        </div>
        <!--报账文本弹窗 start-->
        <el-dialog
          title="报账内容"
          :visible.sync="dialogAccountLock"
          width="600px"
          :show-close="false">
          <div style="white-space: pre-wrap; max-height: 400px; overflow-y: auto" v-html="accountText"></div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" :loading="btnLoading" @click="dialogClose(1)">确 定</el-button>
          </span>
        </el-dialog>
        <!--报账文本弹窗 end-->
        <!--拒绝弹窗 start-->
        <el-dialog
          title="拒绝信息"
          :visible.sync="dialogRefuseLock"
          width="600px"
          :show-close="false">
          <el-form label-width="120px">
            <el-row>
              <el-col :span="24">
                <el-form-item label="财务备注：">
                  <el-input
                    type="textarea"
                    :rows="4"
                    resize="none"
                    placeholder="请输入内容"
                    v-model="refuseText">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button type="info" @click="dialogClose(2)">取 消</el-button>
            <el-button type="primary" :loading="btnLoading" @click="saveRefuseTrade">确 定</el-button>
          </span>
        </el-dialog>
        <!--拒绝弹窗 end-->
        <!--到账确认弹窗 start-->
        <el-dialog
          :title="onlyUpdateConfirmTime ? '修改到账时间' : '到账确认'"
          :visible.sync="dialogConfirmLock"
          width="600px"
          :show-close="false">
          <el-form label-width="120px">
            <el-row>
              <el-col :span="24">
                <el-form-item label="到账时间：">
                  <el-date-picker
                    v-model="confirmTime"
                    type="date"
                    value-format="timestamp"
                    placeholder="选择到账日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button type="info" @click="dialogClose(3)">取 消</el-button>
            <el-button type="primary" :loading="btnLoading" :disabled="!confirmTime" @click="saveConfirmDialog">确 定</el-button>
          </span>
        </el-dialog>
        <!--到账确认弹窗 start-->
      </div>
    </div>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs';
import tableList from '@/components/data/tableList';
import { formatCurrency } from '@/utils/utils';

const tagColors = {
  3: 'success',
  2: 'danger',
  1: 'primary',
  0: 'warning',
};

export default {
  data() {
    return {
      tagColors,
      activeName: 'gkry', // 当前项目
      searchData: {
        pub_userid: '',
        pub_account: '',
        pub_teacher: '',
        project_id: '',
        big_order_no: '',
        order_no: '',
        transaction_id: '',
        payment_method: '',
        total_amount: ['', ''],
        trade_type: '',
        finance_status: '',
        finance_message: '',
        foreign_currency: '', // 是否为外币
      },
      getListurl: '/finance/trade/pagetable', // 表格数据源
      currentRowId: '', // 弹窗id
      dialogAccountLock: false, // 报账文本弹窗锁
      dialogRefuseLock: false, // 拒绝报账弹窗锁
      dialogConfirmLock: false, // 到账确认弹窗锁
      accountText: '', // 报账文本弹窗内容
      refuseText: '', // 拒绝弹窗文本
      selectDict: {}, // 下拉框字典
      confirmTime: null, // 到账日期
      onlyUpdateConfirmTime: false, // 只更新时间
      btnLoading: false,
      currencyUnit: 1 // 总额单位
    };
  },
  computed: {
  },
  methods: {
    // 获取页面数据
    getPageData() {
      this.$http
        ._post({
          url: '/finance/trade/searchDs'
        })
        .then((res) => {
          this.selectDict = res.data;
        });
    },
    // 重置搜索
    resetFields() {
      Object.keys(this.searchData).forEach((k) => {
        this.searchData[k] = '';
      });
      this.searchData.total_amount = [];
      this.$store.commit('updateRefresh', true);
    },
    // 关闭弹窗
    dialogClose(check) {
      switch (check) {
        case 1:
          this.dialogAccountLock = false;
          break;
        case 2:
          this.dialogRefuseLock = false;
          break;
        case 3:
          this.dialogConfirmLock = false;
          break;
        default:
          break;
      }
    },
    // 打开报账文本弹窗
    openAccountDialog(row) {
      this.dialogAccountLock = true;
      this.accountText = row.trade_text;
    },
    // 历史支付点击
    searchHistory(row) {
      this.resetFields();
      this.searchData.project_id = row.project_id;
      this.searchData.pub_userid = row.pub_userid;
      this.$store.commit('updateRefresh', true);
    },
    // 到账确认
    confirmTrade(row) {
      this.currentRowId = row.id;
      this.dialogConfirmLock = true;
      this.onlyUpdateConfirmTime = false;
    },
    // 修改到账时间
    editConfirmTime(row) {
      this.confirmTime = (new Date(row.confirm_time)).getTime();
      this.currentRowId = row.id;
      this.dialogConfirmLock = true;
      this.onlyUpdateConfirmTime = true;
    },
    // 到账提交保存
    saveConfirmDialog() {
      const url = this.onlyUpdateConfirmTime ? '/finance/trade/saveConfirmTime' : '/finance/trade/financeConfirm';
      const msg = this.onlyUpdateConfirmTime ? '修改到账时间成功' : '报账操作成功';

      this.$http
        ._post({
          url: url,
          data: { id: this.currentRowId, confirmTime: this.confirmTime / 1000 }
        })
        .then(() => {
          this.$message.success(msg);
          this.dialogConfirmLock = false;
          this.$store.commit('updateRefresh', true);
        });
    },
    // 拒绝报账打开
    refuseTrade(row) {
      this.currentRowId = row.id;
      this.dialogRefuseLock = true;
    },
    // 拒绝弹窗保存
    saveRefuseTrade() {
      this.$http
        ._post({
          url: '/finance/trade/financeRefuse',
          data: { id: this.currentRowId, message: this.refuseText }
        })
        .then(() => {
          this.$message.success('拒绝完成');
          this.dialogRefuseLock = false;
          this.$store.commit('updateRefresh', true);
        });
    },
    // 导出明细
    exportDetails() {
      this.btnLoading = true;
      this.$http
        ._post({
          url: '/finance/trade/downloadExcel',
          data: { searchData: this.searchData }
        })
        .then(({ data }) => {
          this.$http._download({
            filename: data,
            download: '支付明细.xlsx'
          });
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    // 价格格式化
    formatCurrency(price) {
      return formatCurrency(price);
    }
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-tableList': tableList
  },
  mounted() {
    this.getPageData();
  }
};
</script>
<style scoped>
  .tableList .el-button{
    padding: 0 13px;
  }
</style>
